module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "authors-note"
    }
  }, [_c('h1', [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', [_vm._v("This is fiction. However, everything in this fiction is based on facts. Hence, this is fiction based on facts. In other words, this is fact-based fiction.")]), _vm._v(" "), _c('p', [_vm._v("This is what I see through the peeping hole of my mind when I am silent in the long silence with no thought in it.")]), _vm._v(" "), _c('p', [_vm._v("Kè Su Thar")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1d7b040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch005.vue
// module id = 75
// module chunks = 0